import { CarouselBreakpointsOption } from './carousel-breakpoint-options.interface';

export interface CarouselBreakpoint {
  [key: string]: CarouselBreakpointsOption;
}
